module.exports = __webpack_public_path__ + "img/form__send.ba5fbdc7.svg";